var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-display"
  }, [_c('div', {
    staticClass: "left-column"
  }, [_c('h1', {
    staticClass: "main-title"
  }, [_vm._v(_vm._s(_vm.data.outer_title))]), _c('div', {
    staticClass: "content-wrapper"
  }, _vm._l(_vm.data.subsequent_texts, function (block, index) {
    return _c('div', {
      key: index,
      staticClass: "info-card"
    }, [block.type === 'text' ? _c('InfoText', {
      attrs: {
        "title": block.title,
        "content": block.content
      }
    }) : block.type === 'text-emphasized' ? _c('InfoTextEmphasized', {
      attrs: {
        "title": block.title,
        "content": block.content
      }
    }) : block.type === 'image' ? _c('InfoImage', {
      attrs: {
        "title": block.title,
        "src": block.src,
        "alt": block.alt
      }
    }) : block.type === 'accordion' ? _c('InfoAccordion', {
      attrs: {
        "title": block.title,
        "content": block.content
      }
    }) : _vm._e()], 1);
  }), 0)]), _vm._m(0)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "right-image"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/web/tongxin/bg_content_22.png"),
      "alt": "Doctor illustration"
    }
  })]);
}]

export { render, staticRenderFns }